import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ModuleItem } from '../../types';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-sidebar-block, li[app-sidebar-block]',
    templateUrl: './sidebar-block.component.html',
    standalone: false,
})
export class SidebarBlockComponent implements OnInit, OnDestroy {
    private router = inject(Router);

    @Input() moduleItem: ModuleItem;
    @Input() isExpanded: boolean;

    isActive = false;
    private routerSubscription: Subscription;

    ngOnInit(): void {
        this.checkIfActive();

        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.checkIfActive();
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    private checkIfActive(): void {
        const currentPath = this.router.url;
        this.isActive = currentPath === this.moduleItem.href;
    }

    handleExternalClick(module: ModuleItem): void {
        this.isActive = true;
        window.open(module.href, '_blank', 'noopener');
    }
}
